<template>
    <!-- 影像服务路由 -->
    <div class="photograph_box">
        <banner-carousel></banner-carousel>
        <div class="photograph_list_box">
            <div class="container">
                <photograph-phototheme></photograph-phototheme>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    components:{
        bannerCarousel: () => import('@/components/bannerCarousel'),
        photographPhototheme: () => import('@/components/photographPhototheme'),
    },
    methods: {
        ...mapActions([
            "loadPhotographyCatalog",
            "getPhotographBanner",
        ]),
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.loadPhotographyCatalog().catch(() => {});
            vm.getPhotographBanner();
        })
    },
}
</script>

<style>
/* element ui el-card */
.photograph_box .el-card.is-hover-shadow:hover{
    box-shadow:5px 5px 5px 0 rgba(0,0,0,.3);
}
.photograph_box{
    background-color: #fafafa;
    background-size: cover;
}
/* 预约拍照内容区域 */
.photograph_list_box{
    padding-bottom: 80px;
}
@media (max-width: 767px){
    .photograph_list_box{ padding-bottom: 48px; }
}
</style>
